import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '../../../../environments/environment';
import { replaceStringParams } from 'app/helpers';

import { BootstrapTrackingPageSuccessPayload } from './tracking-page.actions';
import { TrackingPageModel } from 'app/core';

const TRACKING_PAGE_BOOTSTRAP = `${environment.apiUrl}/public/tracking_page_links/:hash/bootstrap`;

const TRACKING_PAGE_BY_SUBDOMAIN = `${environment.apiUrl}/public/tracking_page_by_domain`;

const FIND_TRACKING_PAGE_NUMBER = `${environment.apiUrl}/public/tracking_page_by_domain/:subdomain/link_search`;

const THEME_ID_PARAM_KEY = 'themeId';

@Injectable()
export class TrackingPageDataService {
  constructor(private http: HttpClient) {}

  static getThemeId() {
    const params = new URLSearchParams(window.location.search);
    return params.get(THEME_ID_PARAM_KEY);
  }

  getDomain() {
    const isDomainOnly = window.location.hostname.split('.').length === 2;
    if (isDomainOnly) {
      return window.location.hostname;
    }
    const [subdomain, ...domain] = window.location.hostname.split('.');
    return this.isCustomDomain(domain.join('.'))
      ? window.location.hostname
      : subdomain;
  }

  isCustomDomain(domain: string): boolean {
    return !environment.appUrl.includes(domain);
  }

  addDomainParams(queryParams) {
    const params = new HttpParams()
      .append('domain', queryParams.domain || this.getDomain())
      .append('_locale', queryParams.locale)
      .append(THEME_ID_PARAM_KEY, TrackingPageDataService.getThemeId());
    return {
      params
    };
  }

  bootstrapTrackingPage(params) {
    return this.http.get<BootstrapTrackingPageSuccessPayload>(
      replaceStringParams(TRACKING_PAGE_BOOTSTRAP, { hash: params.hash }),
      this.addDomainParams(params)
    );
  }

  fetchTrackingPageBySubdomain(params) {
    return this.http.get<TrackingPageModel>(
      `${TRACKING_PAGE_BY_SUBDOMAIN}/${params.subdomain}`,
      this.addDomainParams(params)
    );
  }

  findTrackingPageNumber(params) {
    return this.http.get<{ link: string; text: string }>(
      `${replaceStringParams(FIND_TRACKING_PAGE_NUMBER, {
        subdomain: params.subdomain
      })}/${encodeURIComponent(params.searchText)}`,
      this.addDomainParams(params)
    );
  }
}
